module.exports = __webpack_public_path__ + "static/bilaal-cover-0a293988a3e572c6f090e0f8ebc587b9.png";